/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */
<template>
  <div>
    <div
      v-if="!assignmentsDataLoaded"
      class="text-center"
    >
      <h2>
        <svg
          class="icon-refresh rotate large-spinner"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
        </svg>
        Loading...
      </h2>
    </div>

    <div v-if="assignmentsDataLoaded">
      <h2>
        Shared Recordings for {{ assignment.name }}
        <small style="white-space: nowrap;">
          [
          <router-link
            :to="{ name: 'speaker-dashboard' }"
          >
            Return to Dashboard
          </router-link>
          ]
        </small>
      </h2>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th
              width="50%"
              scope="col"
            >
              Name
            </th>
            <th
              width="50%"
              scope="col"
            >
              Number of Shared Recordings
            </th>
          </tr>
        </thead>
        <tbody v-for="(speaker, index) in speakers">
          <tr :class="{ active: index % 2 == 0 }">
            <th scope="row">
              <a
                v-if="speaker.recordings.length > 0"
                href="#"
                @click.prevent="expand(speaker)"
              >
                {{ speaker.name }}
              </a>
              <span v-if="speaker.recordings.length == 0">
                {{ speaker.name }}
              </span>
            </th>
            <td>{{ speaker.recordings.length }}</td>
          </tr>
          <tr
            v-if="speaker.recordings.length > 0"
            v-show="speaker.showRecordings"
            :class="{ active: index % 2 == 0 }"
          >
            <td
              colspan="4"
              class="well"
              style="padding-left:10%"
            >
              <table class="table table-condensed table-bordered">
                <caption>Recordings for {{ speaker.name }}</caption>
                <thead>
                  <tr>
                    <th
                      width="50%"
                      scope="col"
                    >
                      Title
                    </th>
                    <th
                      width="20%"
                      scope="col"
                    >
                      Submitted?
                    </th>
                    <th
                      width="30%"
                      scope="col"
                    >
                      History
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="recording in speaker.recordings">
                    <th scope="row">
                      <router-link
                        :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId }, query: { assignment: assignment.name, assignmentId: assignment.assignmentId } }"
                      >
                        {{ recording.title }}
                      </router-link>
                    </th>
                    <td>
                      {{ recording.submitted ? 'Yes' : 'No' }}<br>
                    </td>
                    <td>
                      Created {{ recording.createdDate | date }}<br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<style lang="less" scoped>
  @media print {
    #my-groups-form, ul.nav-tabs {
      display: none;
    }
    div.tab-well {
      border: 0px;
    }
  }
  #newGroup {
    width: 255px;
    display: inline;
  }
  label[for=newGroup] {
    margin-right: 4px;
  }
</style>

<script>
import SpeakerAssignments from './SpeakerAssignments';

export default {
  mixins: [SpeakerAssignments],
  data() {
    return {
      assignment: null,
      speakers: [],
    };
  },
  methods: {
    assignmentsLoaded() {
      let users = _.cloneDeep(this.assignment.userTargets);
      _.forEach(users, (u) => {
        const allRecs = this.assignmentRecordingsByAssignment[this.assignment.assignmentId];
        u.recordings = allRecs[u.userId] || [];
        if (window.__activeSpeaker && window.__activeSpeaker.userId === u.userId) {
          u.showRecordings = true;
        }
      });
      this.speakers = users;
    },
    expand(speaker) {
      this.$forceUpdate();
      speaker.showRecordings = !speaker.showRecordings;
      if (speaker.showRecordings) {
        window.__activeSpeaker = speaker;
      }
    }
  }
};
</script>
